import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import { Button, InputLabel } from "@mui/material";
import styles from "../../../../customer/styles/customerStyles.module.css";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { Icon } from "@iconify/react";
import InputField from "../../../../../Authentication/components/InputField";
import { shippingOrder } from "../../../../../api/order";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35%",
  height: "auto",
  textAlign: "center",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  p: "20px 50px",
  borderRadius: "10px",
};

export default function OrderShippingModal({ orderId }) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [trackingNumber, setTrackingNumber] = useState("");
  const dispatch = useDispatch();

  return (
    <>
      <Icon
        icon="material-symbols:edit-square-outline"
        width="20"
        height="20"
        style={{ cursor: "pointer", marginRight: "5px" }}
        onClick={handleOpen}
      />

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
      >
        <Fade in={open}>
          <Box sx={style} className="">
            <>
              <h2
                className={styles.welcome_popup}
                style={{ marginBottom: "20px" }}
              >
                Ship Order
              </h2>
              <InputLabel sx={{ margin: 0, textAlign: "left", color: "#000" }}>
                Tracking number
              </InputLabel>
              <InputField
                label="Tracking number"
                placeholder="tracking number"
                name="tracking_number"
                value={trackingNumber}
                onChange={(e) => setTrackingNumber(e.target.value)}
                type="text"
                size="small"
              />

              <Button
                variant="lightblue"
                disabled={trackingNumber === ""}
                sx={{
                  width: "auto",
                  borderRadius: "5px",
                }}
                onClick={() => {
                  dispatch(
                    shippingOrder({
                      orderId: orderId,
                      updateDetails: {
                        // status: status,
                        // time_in_transit: time,
                        tracking_numbers: trackingNumber,
                      },
                    })
                  );
                  handleClose();
                }}
              >
                Update
              </Button>
            </>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}
